// extracted by mini-css-extract-plugin
export var dropdown = "_ds-0";
export var imagePlaceholder = "_ds-2";
export var imageWrapper = "_ds-3";
export var productImage = "_ds-1";
export var truncateContainer = "_ds-4";
export var truncateText = "_ds-5";